import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

const allowedOrigins = [
  'https://api.flex-charge.com',
  'https://api-staging.flex-charge.com',
  'https://api-sandbox.flex-charge.com',
  'https://api.flexfactor.io',
  'https://api-staging.flexfactor.io',
  'https://api-sandbox.flexfactor.io',
];

Sentry.init({
  dsn: 'https://95b572065774c2e548cd79ad6c684e56@o1378422.ingest.us.sentry.io/4509440831324160',
  release: 'fc-ui-widget-shell@' + process.env.REACT_APP_ENVIRONMENT,
  integrations: [
    new BrowserTracing({
      tracingOrigins: allowedOrigins,
      shouldCreateSpanForRequest: (url: string): boolean => {
        return allowedOrigins.some(origin => url.startsWith(origin));
      },
      // Disable browser event tracking to save costs
      startTransactionOnLocationChange: false,
      startTransactionOnPageLoad: false,
      // Drop any navigation transactions that might still be created
      beforeNavigate: (): undefined => {
        return undefined; // This drops the transaction
      },
    }),
  ],
  enabled: process.env.REACT_APP_ENVIRONMENT === 'production',
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_ENVIRONMENT,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

reportWebVitals();
